/**
 * Created by kb on 2018/01/23.
 */
import {http_Req, url, METHODS} from '@/api/httpService'
import {util} from '@/commonJs/util'
import  {menuPage} from  '@/commonJs/commonconf'
import {reqUrlConf}  from  '@/commonJs/reqconf';

let date = new Date();

let $ChartVue = null,isSendT = 0 ,callbackUnread = null //接收到未读消息回调方法;
let msgType= {
  text: "text",
  more: "more",
  img: "img"
}
const state = function () {

  return {
    sessions: [
      //   {
      //   name: "小李",
      //   id: 2,
      //   img: require("@/assets/images/2.png"),
      //   messages: []
      // }
    ],  //当前会话列表
    curSessionId: 0, //当前会话
    filterKey: "",    //过滤会话的筛选条件
    user: {
      name: "",
      img: require("@/assets/images/4.jpg"),
      uid: "",
    },      //当前登录人的信息
    currentCount: 3,  //当前会话总人数
    connection: null,//websocket链接对象
    NotConnect: true,//是否未连接websocket服务器
    $vue: null,//页面vue对象
    isAutoClose: false,  //是否手动关闭连接
    isFirstConnect: true, //是否首次连接
    connectLoading: false, //重新连接按钮加载中
    isConnectResult: false,  //连接是否返回结果
    isErrorResult: false,  //错误或关闭连接是否返回结果
    chartShow: false, //聊天窗口是否在显示状态
    historySession: {
      name: "",//被聊天人的名称
      img: require("@/assets/images/2.png"),
      messages: [] //聊天记录
    },//历史记录消息数据
  }

}


const mutations={
  Set_CurSessionId: (state, curSessionId) => {
    state.curSessionId = curSessionId;
  },
  Set_FilterKey: (state, filterKey) => {
    state.filterKey = filterKey;
  },
  Set_Sessions: (state, sessions) => {
    state.sessions = sessions;
  },
  Set_Messages: (state, {messages,sessionKey}) => {
    let session = state.sessions.find(item => item.sessionKey === sessionKey);
    if (session) {
      session.messages = messages;
    }
  },
  Set_SessionsVbyK: (state, {sessionKey,Key,Value}) => {
    let session = state.sessions.find(item => item.sessionKey === sessionKey);
    if (session) {
      session[Key] = Value;
    }
  },
  Set_NotConnect: (state, NotConnect) => {
    state.NotConnect = NotConnect;
  },
  Set_ConneCtion: (state, connection) => {
    state.connection = connection;
  },
  Set_Vue: (state, VUE) => {
    state.$vue = VUE;
  },
  Set_IsAutoClose: (state, isAutoClose) => {
    state.isAutoClose = isAutoClose;
  },
  Set_User: (state, user) => {
    state.user = {...user};
  },
  Add_Session:(state, session)=> {
    state.sessions.push({...session})
  },
  Set_IsFirstConnect: (state, isFirstConnect) => {
    state.isFirstConnect = isFirstConnect;
  },
  Set_ConnectLoading: (state, connectLoading) => {
    state.connectLoading = connectLoading;
  },
  Set_IsConnectResult: (state, isConnectResult) => {
    state.isConnectResult = isConnectResult;
  },
  Set_isErrorResult: (state, isErrorResult) => {
    state.isErrorResult = isErrorResult;
  },
  Set_chartShow: (state, chartShow) => {
    state.chartShow = chartShow;
  },
  Set_historySession: (state, kv) => {
    Object.keys(kv).forEach(function (key, index) {
      if (state.historySession[key]!= undefined) {
        state.historySession[key] = kv[key];
      }
    })
  },
};


const  actions= {
  /**
   * 设置当前选中会话的id
   * @param commit
   * @param state
   * @param curSessionId
   */
  setCurSessionId({commit, state}, curSessionId){
    commit("Set_CurSessionId", curSessionId);
  },
  //设置会话筛选条件
  searchSession({commit, state}, filterKey){
    commit("Set_FilterKey", filterKey);
  },
  //设置会话列表
  setSessions({commit, state}, sessions){
    commit("Set_Sessions", sessions);
  },
  //清空当前选中会话的未读消息
  selectSession({commit, state, dispatch}, curSessionId){
    commit("Set_CurSessionId", curSessionId);
    let session = state.sessions.find(item => item.id === curSessionId);
    if (session) {
      //把未读消息清空
      if (session.unreadMsgCount > 0) {
        commit("Set_SessionsVbyK", {
          sessionKey: session.sessionKey,
          Key: "unreadMsgCount",
          Value: 0
        });
        let sum = state.sessions.sum("unreadMsgCount");
        callbackUnread(sum);
      }
    }
  },
  /**
   * 发送消息
   * @param commit
   * @param state
   * @param dispatch
   * @param content
   */
  sendMessage({commit, state, dispatch}, content){
    if (!state.NotConnect) {
      let session = state.sessions.find(item => item.id === state.curSessionId);
      if (session) {
        let messages = [...session.messages];
        messages.push({
          content: content,
          date: new Date(),
          self: true,
          type: msgType.text,
          id: (messages.length + 1 ),
        });
        isSendT = setTimeout(function () {
          commit("Set_Messages", {messages, sessionKey: session.sessionKey});
        },700)
        let msgJson = {};
        msgJson.fromId = menuPage.loginUser.id;
        msgJson.fromName = menuPage.loginUser.userName || menuPage.loginUser.account;
        msgJson.toId = session.sessionKey;
        msgJson.message = content;
        state.connection.send(JSON.stringify(msgJson));
      } else {
        // popUpMsg('请选择一个会话发送消息','error')
      }
    } else {
      // popUpMsg('会话已断开连接，请重新连接','error')
    }
  },
  /**
   * 接收消息
   * @param commit
   * @param state
   * @param dispatch
   * @param userContent
   */
  receiveMessage({commit, state, dispatch}, conn){
    //首次连接时，加载客户列表
    /*
    if(conn){
      var com=[{ fromName:"1111",fromId:"1111",compName:"上海陌远",sessionKey:"1111" },{ fromName:"2222",fromId:"2222",compName:"杭州陌远",sessionKey:"2222" }];
      com && com.constructor == Array && com.forEach((itemcom, index) => {
        let session= state.sessions.find(item => item.sessionKey === itemcom.fromId);
        if(!session){
          session = {
            name: itemcom.fromName,
            compName:itemcom.compName,
            id: (state.sessions.length + 1),
            img: require("@/assets/images/2.png"),
            messages: [],
            sessionKey: itemcom.fromId,
            unreadMsgCount: 0
          }
          commit("Add_Session", session);
        }
      });
    }*/

    conn.onmessage = function (evt) {
      let msg = JSON.parse(evt.data);

      //如果消息是自己推送给自己的
     /* if (msg.fromId === state.user.uid && msg.messageType !== "error" && msg.messageType !== "syserror") {

      } else {*/
        if (msg.messageType === "error") {
          // popUpMsg("消息发送失败：" + msg.message, 'error');
          clearTimeout(isSendT);
        }
        else if (msg.messageType === "serverdown"){
          //popUpMsg("发送成功（离线消息）");
          // clearTimeout(isSendT);
          commit("Set_SessionKey", {curId: state.curSessionId, sessionKey: "", name: ""});
        }
        else if (msg.messageType === "syserror") {
          // popUpMsg(msg.message, 'error');
        }
        //离线消息
        else if (msg.messageType === "offmessage") {
          msg.wsMessagePOs && msg.wsMessagePOs.constructor == Array && msg.wsMessagePOs.forEach((itemMs, index) => {
            let session = state.sessions.find(item => item.sessionKey === itemMs.fromId);
            if (!session) {
              session = {
                name: itemMs.fromName,
                compName:"",
                id: (state.sessions.length + 1),
                img: require("@/assets/images/2.png"),
                messages: [],
                sessionKey: itemMs.fromId,
                unreadMsgCount: 0
              }
              commit("Add_Session", session);
              //查询客户公司名称接口
              http_Req(METHODS.GET, reqUrlConf.getClientCompName,{userId:itemMs.fromId}).then(({reqStatus, record, errMsg}) => {
                if (reqStatus) {
                  commit("Set_SessionsVbyK", {
                    sessionKey: session.sessionKey,
                    Key: "compName",
                    Value: record
                  });
                }
              }).catch((e)=>{})
            }
            let messages = [...session.messages];
            messages.push({
              content: itemMs.message,
              date: itemMs.createOn,
              self: (itemMs.fromId === menuPage.loginUser.id),
              type: msgType.text,
              id: (messages.length + 1 ),
            });
            commit("Set_Messages", {messages, sessionKey: session.sessionKey});
            if (session.id != state.curSessionId || !state.chartShow) {
              commit("Set_SessionsVbyK", {
                sessionKey: session.sessionKey,
                Key: "unreadMsgCount",
                Value: (session.unreadMsgCount + 1)
              });
              let sum = state.sessions.sum("unreadMsgCount");
              callbackUnread(sum);
            }

          })
        }
        else if (msg.messageType === "closeerror") {
          commit("Set_IsConnectResult", true);
          commit("Set_isErrorResult", true);
          //popUpMsg(msg.message, 'error');
        }
        else {
          let session = state.sessions.find(item => item.sessionKey === msg.fromId);
          if (!session) {
            session = {
              name: msg.fromName,
              compName:"",
              id: (state.sessions.length + 1),
              img: require("@/assets/images/2.png"),
              messages: [],
              sessionKey: msg.fromId,
              unreadMsgCount: 0
            }
            commit("Add_Session", session);
            http_Req(METHODS.GET, reqUrlConf.getClientCompName, {userId:msg.fromId}).then(({reqStatus, record, errMsg}) => {
              if (reqStatus) {
                commit("Set_SessionsVbyK", {
                  sessionKey: session.sessionKey,
                  Key: "compName",
                  Value: record
                });
              }
            }).catch((e)=> {})
          }
          let messages = [...session.messages];
          messages.push({
            content: msg.message,
            date: new Date(),
            self: (msg.fromId === menuPage.loginUser.id),
            type: msgType.text,
            id: (messages.length + 1 ),
          });
          commit("Set_Messages", {messages, sessionKey: session.sessionKey});
          if (session.id != state.curSessionId || !state.chartShow) {
            commit("Set_SessionsVbyK", {
              sessionKey: session.sessionKey,
              Key: "unreadMsgCount",
              Value: (session.unreadMsgCount + 1)
            });
            let sum = state.sessions.sum("unreadMsgCount");
            callbackUnread(sum);
          }
        }
      //}
    }
  },
  /**
   * 初始化会话连接
   * @param commit
   * @param state
   * @param dispatch
   * @param $vue 聊天界面vm对象
   * @param callBack  接受到未读消息后的回调方法
   * @param isFirst //是否首次连接
   * @returns {Promise}
   */
  initConnect({commit, state, dispatch}, {$vue,callBack,isFirst=true}){
    return new Promise((resolve, reject) => {
      if (!state.connection || state.connection.readyState != 1) {
        callbackUnread = callBack;
        let wsUrl;
        if(process.env.NODE_ENV === 'production') {
          wsUrl = window.location.origin.substring(7) + '/ylb-web/websocket';
        }else{
          wsUrl = process.env.webSocketUrl;
        }
        let conn = new WebSocket('ws://' + wsUrl + '/' + menuPage.loginUser.id + '/service');
        $ChartVue = $vue;
        commit("Set_IsFirstConnect", isFirst);
        commit("Set_IsConnectResult", false);
        commit("Set_isErrorResult", false);
        //连接成功执行的方法
        conn.onopen = function (evt) {
          commit("Set_IsAutoClose", false);
          //设置已返回结果
          if (!state.isConnectResult) {
            commit("Set_IsConnectResult", true);
          }
          //延迟执行
          setTimeout(function () {
            commit("Set_NotConnect", false); //设置已与服务器建立连接
            if(!state.isConnectResult) {
              // popUpMsg('连接服务器成功')
            }

            //判断是否首页连接
            if (state.isFirstConnect) {
              commit("Set_IsFirstConnect", false);
            }

            //判断是否正在连接中
            if (state.connectLoading) {
              commit("Set_ConnectLoading", false);
            }

            resolve()
          }, 1000)

        }


        //连接失败执行的方法
        conn.onclose = function (evt) {
          //判断是否首页连接
          if (state.isFirstConnect) {
            commit("Set_IsFirstConnect", false);
          }

          //设置已返回结果
          if (!state.isConnectResult) {
            commit("Set_IsConnectResult", true);
          }

          //延迟执行
          setTimeout(function () {
            commit("Set_NotConnect", true);
            //判断是否手动点击关闭聊天窗口
            if (!state.isAutoClose && !state.isErrorResult) {
              // popUpMsg('服务器连接已关闭', 'error')
              reject(new Error("连接断开"))
            }
            commit("Set_isErrorResult", true);
            //判断是否正在连接中
            if (state.connectLoading) {
              commit("Set_ConnectLoading", false);
            }

          }, 1000)

        }


        //连接错误执行的方法
        conn.onerror = function (evt) {

          //判断是否首页连接
          if (state.isFirstConnect) {
            commit("Set_IsFirstConnect", false);
          }
          //设置已返回结果
          if (!state.isConnectResult) {
            commit("Set_IsConnectResult", true);
          }
          //延迟执行
          setTimeout(function () {
            commit("Set_NotConnect", true);
            if (!state.isErrorResult) {
              // popUpMsg('连接服务器失败', 'error')
            }
            //判断是否正在连接中
            if (state.ConnectLoading) {
              commit("Set_ConnectLoading", false);
            }
            commit("Set_isErrorResult", true);
            reject(new Error("连接服务器失败"))

          }, 1000)

        }

        //接收消息
        dispatch("receiveMessage", conn);

        commit("Set_ConneCtion", conn);
        commit("Set_User", {
          name: (menuPage.loginUser.userName || menuPage.loginUser.account),
          img: require("@/assets/images/4.jpg"),
          uid: menuPage.loginUser.id
        });

        //连接超时执行方法
        setTimeout(function () {
          if (!state.isConnectResult) {
            conn.onopen = () => {
            };
            conn.onclose = () => {
            };
            conn.onerror = () => {
            };
            conn.onmessage = () => {
            };
            state.connection.close();
            // popUpMsg('连接服务器超时，请重新连接', 'error');
            commit("Set_ConnectLoading", false);
            commit("Set_NotConnect", true);

            //判断是否首页连接
            if (state.isFirstConnect) {
              commit("Set_IsFirstConnect", false);
            }
            reject(new Error("连接失败"))
          }
        }, 10000)

      }
    })
  },
  //关闭整个会话
  closeConnect({commit, state, dispatch}){
    commit("Set_IsAutoClose", true);
    state.connection.close();
    commit("Set_NotConnect", true);
    state.connection.onopen = () => {
    };
    state.connection.onclose = () => {
    };
    state.connection.onerror = () => {
    };
    state.connection.onmessage = () => {
    };
    commit("Set_ConneCtion", null);
    commit("Set_Sessions", []);
    commit("Set_Vue", null);
    commit("Set_CurSessionId", 0);
    //清空整个未读消息数量
    callbackUnread(0);
    callbackUnread = null;
  },
  //关闭指定会话
  closeSessionById({commit, state, dispatch}, curId){
    let sessions = [...state.sessions];
    let index = sessions.findIndex((item,index)=> {
      return item.id === curId;
    })
    if(index>=0) {
      sessions.splice(index, 1);
      commit("Set_Sessions", sessions);
      commit("Set_CurSessionId", 0);
      let sum = state.sessions.sum("unreadMsgCount");
      callbackUnread(sum);
    }
  },
  //重新连接
  restConnect({commit, state, dispatch}){
    if(!state.connectLoading) {
      commit("Set_ConneCtion", null); //设置连接对象为空  以便重新建立连接对象
      commit("Set_ConnectLoading", true);//设置正在加载中
      dispatch("initConnect", {$vue: $ChartVue,callBack:callbackUnread, isFirst: false});
    }
  },
  //同步历史记录消息
  synchroHistory({commit, state, dispatch},{date}){
    let historySession ={};
    let historyMsgs = [];//历史记录集合
    historySession.messages = [...historyMsgs] ;
    commit("Set_historySession", {...historySession});
    return new Promise((resolve, reject) => {
      setTimeout(function () {

        let session = state.sessions.find(item => item.id === state.curSessionId);//获取当前会话
        if (session && util.notBlank(session.sessionKey)) {
          //拉取与客服聊天记录的数据
          http_Req(METHODS.GET, reqUrlConf.synchroHistory, {
            createOn: (date.constructor === String ? date : util.formatDate.format(date, "yyyy-MM-dd")),
            toId: session.sessionKey
          }).then(({reqStatus, record, errMsg}) => {
            if (reqStatus) {
              //构造数据 循环添加历史记录
              record.forEach((item, index) => {
                historyMsgs.push({
                  content: item.message,
                  date:  util.notBlank(item.createOn) ? item.createOn.timeformatDate("yyyy-MM-dd hh:mm:ss"):"" ,
                  self: (item.fromId === state.user.uid),
                  type: msgType.text,
                  id: (historyMsgs.length + 1 ),
                });
              });
              historySession.name = session.name;
              historySession.messages = [...historyMsgs] ;

              commit("Set_historySession", historySession);//拼装好的历史数据提交到state
              resolve();
            } else {
              // popUpMsg('同步聊天记录失败', "error");
              reject(new Error("同步聊天记录失败"));
            }
          }).catch((e) => {
            // popUpMsg('同步聊天记录失败', "error");
            reject(new Error("同步聊天记录失败"));
          })
        } else {
          // popUpMsg('未连接客服', "error")
        }
      }, 600)

    });
  },
  //设置聊天窗口是否显示的值
  setChartShow({commit, state, dispatch},chartShow){
    commit("Set_chartShow", chartShow);
    if (chartShow) {
      let session = state.sessions.find(item => item.id === state.curSessionId);
      if (session) {
        //把未读消息清空
        if (session.unreadMsgCount > 0) {
          commit("Set_SessionsVbyK", {
            sessionKey: session.sessionKey,
            Key: "unreadMsgCount",
            Value: 0
          });
          let sum = state.sessions.sum("unreadMsgCount");
          callbackUnread(sum);
        }
      }
    }
  }
}


const getters ={
  sessions: ({filterKey, sessions}) => {
    if (filterKey != "") {
      return sessions.filter(session => {
        return session.name.toString().indexOf(filterKey) >= 0
      });
    }
    return sessions;
  },
  curId: ({curSessionId}) => {
    return curSessionId;
  },
  user: ({user}) => {
    return user;
  },
  curSession: ({sessions,curSessionId}) => {
    return  sessions.find(session => session.id === curSessionId);
  },
  NotConnect: ({NotConnect}) => {
    return NotConnect;
  },
  connection: ({connection}) => {
    return connection;
  },
  isFirstConnect: ({isFirstConnect}) => {
    return isFirstConnect;
  },
  connectLoading: ({connectLoading}) => {
    return connectLoading;
  },
  historySession:({historySession}) => {
    return historySession;
  },
}

/**
 * 弹出消息提示
 * @param msg  消息内容
 * @param type  消息类型
 */
function  popUpMsg(msg,type="success") {
  if (type == "success") {
    $ChartVue.$notify.success({
      message: msg,
      offset: 300,
      duration: 2500,
    });
  } else {
    $ChartVue.$notify.error({
      title: '错误',
      message: msg,
      offset: 300,
      duration: 2500,
    });
  }
}

export const  _state = state;
export const  _mutations = mutations;
export const  _actions = actions;
export const  _getters = getters;

export   default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}


//动态注册模块示例
// this.$store.registerModule("module"+Math.random().toString(), {
//   namespaced: true,
//   state: _state,
//   mutations: _mutations,
//   actions: _actions,
//   getters: _getters
// })



// WEBPACK FOOTER //
// ./src/store/modules/serverWebChart.js